import {Enumify} from "enumify-ts";

class CustomerConsignmentStatusType extends Enumify<CustomerConsignmentStatusType>() {

    static SCHEDULED = new CustomerConsignmentStatusType("SCHEDULED", "#06e6f5");
    static TO_BE_RESCHEDULED = new CustomerConsignmentStatusType("TO BE RESCHEDULED", "#f2930c");
    static IN_TRANSIT = new CustomerConsignmentStatusType("IN TRANSIT", "#bab8f5");
    static ARRIVED = new CustomerConsignmentStatusType("ARRIVED", "#7c5bf5");
    static ON_ROUTE = new CustomerConsignmentStatusType("ON ROUTE", "#0802f5");
    static ON_ITS_WAY = new CustomerConsignmentStatusType("ON ITS WAY", "#108ee9");
    static COMPLETED = new CustomerConsignmentStatusType("COMPLETED", "#87d068");
    static _ = CustomerConsignmentStatusType._closeEnum();

    constructor(
        public description: string,
        public colour: string
    ) {
        super();
    }

}

export default CustomerConsignmentStatusType;
